import { commonOptions, YesNo } from '@/config'
import { filterSubmitData } from '@/utils'
import type { PageContext } from '@zto/zpage'

// 新增/批量新增对话框
export const addDialog = (isManual: Boolean) => {
  return {
    width: 500,
    labelWidth: 100,
    itemSpan: 24,

    onShow: async ({ app, data }: PageContext) => {
      const payload = { ...data }

      if (data.manufacturerCode) {
        const res = await app.request({
          api: '/sys/admin/device/manufacturer/listEnabled',
          params: { manufacturerCode: data.manufacturerCode }
        })

        const mfrList = res?.data || []

        const mfrInfo = mfrList.find((it: any) => it.manufacturerCode === data.manufacturerCode)
        payload._supplyScopeCodes = mfrInfo?.supplyScopeCodes || []
      }

      return { payload }
    },

    beforeSubmit: async ({ app, data }: PageContext, model: any, options: any) => {
      const payload = filterSubmitData(data)
      return payload
    },

    formItems: [
      ...[
        {
          label: '厂商',
          prop: 'manufacturerCode',
          type: 'fuzzy-select',
          labelProp: 'manufacturerName',
          api: '/sys/admin/device/manufacturer/listEnabled',
          optionValueProp: 'manufacturerCode',
          optionLabelProp: 'manufacturerName',
          onChange: (data: any, a: any, b: any, source: any) => {
            data._supplyScopeCodes = source.option.supplyScopeCodes
            data.deviceTypeCode = ''
            data.deviceTypeName = ''
            data.modelCode = ''
            data.modelName = ''
          },
          triggerFocus: true,
          required: true
        },
        {
          type: 'select',
          prop: 'deviceTypeCode',
          labelProp: 'deviceTypeName',
          label: '类型',
          required: true,
          onChange: (data: any, a: any, b: any, source: any) => {
            data.modelCode = ''
            data.modelName = ''
          },
          dynamicAttrs: ({ data }: PageContext) => {
            if (!data.manufacturerCode) {
              data.deviceTypeCode = ''
              data.deviceTypeName = ''
              return { disabled: true }
            }

            const supplyScopeCodes = data._supplyScopeCodes || []
            if (data.deviceTypeCode && !supplyScopeCodes.includes(data.deviceTypeCode)) {
              supplyScopeCodes.push(data.deviceTypeCode)
            }

            const options = commonOptions.tdlDeviceType.filter(it => supplyScopeCodes.includes(it.value))

            return { options }
          }
        },
        {
          label: '型号',
          type: 'fuzzy-select',
          prop: 'modelCode',
          labelProp: 'modelName',
          api: '/sys/admin/device/device-model/listEnabled',
          optionValueProp: 'modelCode',
          optionLabelProp: 'modelName',
          triggerFocus: true,
          required: true,
          dynamicAttrs: ({ data }: PageContext) => {
            if (!data.deviceTypeCode || !data.manufacturerCode) {
              data.modelCode = ''
              data.modelName = ''
              return { disabled: true }
            }

            return {
              apiParams: {
                deviceTypeCode: data.deviceTypeCode,
                manufacturerCode: data.manufacturerCode
              }
            }
          }
        }
      ],
      ...[
        isManual
          ? {
              type: 'input',
              prop: 'snCode',
              label: '手动SN',
              placeholder: '请输入SN，不填写自动生成',
              maxlength: 32,
              trim: true
            }
          : { type: 'input-number', prop: 'quantity', label: '生成数量', max: 1000, required: true }
      ]
    ]
  }
}

const OperateType = Object.freeze({
  RECALL: {
    label: '召回',
    notice: '召回指令将下发至整车聚合接口，车辆将停止配送并返回站点。',
    noticeStyle: 'color: orange; border: 1px solid #FDF0BE; background: #FEFBE6;'
  },
  REBOOT: {
    label: '重启',
    notice: '重启可能导数车辆短暂离线、当前配送任务中断。请确认后再下发。',
    noticeStyle: 'color: blue; border: 1px solid #E6F7FF; background: #E6F7FF;'
  },
  STOP: {
    label: '停止',
    notice: '停止指令用于紧急停车场景，请与召回、车载急停等能力边界区分清楚后再下发.',
    noticeStyle: 'color: red; border: 1px solid #FDE3E0; background: #FEF2F0;'
  }
})

export function logDialog() {
  return {
    title: `操作日志`,

    width: 800,
    labelWidth: 0,
    itemSpan: 24,
    noPadding: true,

    bodyHeight: '400px',

    actions: [{ name: 'close', label: '关闭' }],

    body: ({ data }: PageContext) => {
      return {
        type: 'crud',
        actions: {
          query: {
            api: '/sys/admin/sys-config/queryOptLogList',
            apiParams: { module: 'SN', snCode: data.snCode }
          }
        },
        header: {
          body: {
            type: 'html',
            html: `<div class="q-py-md" style="font-size: 12px;">设备${data.snCode}在平台上的关键操作记录</div>`
          }
        },
        toolbar: { hidden: true },
        search: { hidden: true },
        table: {
          columns: [
            { label: '时间', prop: 'gmtCreate', width: 150 },
            {
              label: '操作类型',
              prop: 'bizTypeName',
              width: 100,
              formatter: { name: 'enumStr', options: commonOptions.tdlOptLogType }
            },
            { label: '操作人', prop: 'operatorName', width: 100 },
            {
              label: '结果',
              prop: 'status',
              width: 80,
              formatter: {
                name: 'enumStr',
                options: [
                  { label: '成功', value: YesNo.YES },
                  { label: '失败', value: YesNo.NO }
                ]
              }
            },
            { label: '详情', prop: 'content', minWidth: 150 }
          ]
        }
      }
    }
  }
}
